<template>
  <div class="search_infoTags"
       v-if="showList.length">
    <!-- <icon class="icon-loudou iconfont_action"></icon>&nbsp;&nbsp;检索项： -->
    <el-tag size="small"
            color="$theme-color"
            class="tagsItem"
            v-for="(item,index) in showList"
            :key="index"
            closable
            @close="closeItem(item,index)">
      {{item.label}}:{{item.value}}
    </el-tag>
    <el-button type="text"
               size="mini"
               class="el-icon-delete delBtn"
               v-show="showList.length"
               @click="closeAll">清空</el-button>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
    data() {
        return {
            showList: [],
        };
    },
    methods: {
        closeItem(item, index) {
            this.$parent.searchForm[item.key] = "";
            this.$parent.searchForm_transfer[item.key]
                ? (this.$parent.searchForm_transfer[item.key] = "")
                : "";
            this.$parent[this.funcName](1);
            this.showList.splice(index, 1);
        },
        closeAll() {
            this.$parent.clean();
            this.$parent[this.funcName](1);
        },
    },
    props: {
        searchForm: Object,
        searchList: Object,
        funcName: String,
    },
    watch: {
        searchForm: {
            handler(newValue) {
                // debugger
                this.showList = [];
                let arr = Object.keys(newValue);
                for (let i in arr) {
                    for (let j in this.searchList) {
                        if (
                            this.searchList[j].type == "input" ||
                            !this.searchList[j].type
                        ) {
                            if (
                                newValue[arr[i]].length &&
                                arr[i] == this.searchList[j].key
                            ) {
                                this.showList.push({
                                    label: this.searchList[j].label,
                                    value: newValue[arr[i]],
                                    key: arr[i],
                                });
                            }
                        } else if (this.searchList[j].type == "select") {
                            let list = this.searchList[j].props.list;
                            for (let n in list) {
                                if (
                                    arr[i] == this.searchList[j].key &&
                                    newValue[arr[i]] ==
                                        list[n][
                                            this.searchList[j].props.valueKey
                                        ]
                                ) {
                                    this.showList.push({
                                        label: this.searchList[j].label,
                                        value: list[n][
                                            this.searchList[j].props.nameKey
                                        ],
                                        key: arr[i],
                                    });
                                }
                            }
                        } else if (this.searchList[j].type == "cascader") {
                            if (
                                arr[i] == this.searchList[j].key &&
                                this.searchList[j].props.length
                            ) {
                                this.showList.push({
                                    label: this.searchList[j].label,
                                    value: this.searchList[j].props.toString(),
                                    key: arr[i],
                                });
                            }
                        }
                    }
                }
                // this.$parent[this.funcName](); //部分筛选条件已绑定事件，会重复调
            },
            deep: true,
            immediate: true,
        },
        showList: {
            handler(newValue) {
                if (newValue.length > 0) {
                    if (this.is_infoTags == "normal") {
                        this.$store.commit("IS_INFOTAGS", "minus");
                    } else if (this.is_infoTags == "minus") {
                        this.$store.commit("IS_INFOTAGS", "minus");
                    } else if (this.is_infoTags == "add") {
                        this.$store.commit("IS_INFOTAGS", "minus");
                    }
                } else {
                    if (this.is_infoTags == "normal") {
                        this.$store.commit("IS_INFOTAGS", "normal");
                    } else if (this.is_infoTags == "minus") {
                        this.$store.commit("IS_INFOTAGS", "normal");
                    } else if (this.is_infoTags == "add") {
                        this.$store.commit("IS_INFOTAGS", "minus");
                    }
                }
            },
            deep: true,
            immediate: false,
        },
    },
    computed: {
        ...mapState({
            is_infoTags: (state) => state.index.is_infoTags,
        }),
    },
};
</script>
<style lang="scss">
.search_infoTags {
    width: 100%;
    line-height: 24px;
    margin-bottom: 8px;
    text-align: left;
    font-size: 12px;
    box-sizing: border-box;
    .tagsItem {
        margin-right: 4px;
    }
    .delBtn {
        color: $color-danger;
    }
    .el-button--mini {
        padding: 5px 0;
    }
}
</style>